import { render, staticRenderFns } from "./userJurisdiction.vue?vue&type=template&id=3341b465&scoped=true&"
import script from "./userJurisdiction.vue?vue&type=script&lang=js&"
export * from "./userJurisdiction.vue?vue&type=script&lang=js&"
import style0 from "./userJurisdiction.vue?vue&type=style&index=0&id=3341b465&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3341b465",
  null
  
)

export default component.exports